//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    service: {
      type: Object,
      default() {
        return {}
      }
    },
    active: {
      type: Boolean,
      default: false
    },
    isSmall: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    // Стоимость услуги
    servicePrice() {
      if (!this.service.price || this.service.price === 0) {
        return 'бесплатно'
      }

      return `${this.service.price} ₽`
    },
    servicePriceOld() {
      if (
        !this.service.price_old ||
        this.service.price_old <= this.service.price
      ) {
        return
      }

      return `${this.service.price_old} ₽`
    },

    // Длительность услуги
    serviceDuration() {
      const duration = this.service.duration

      if (!duration) {
        return null
      }

      const hours = Math.floor(duration / 60)
      const minuts = duration - hours * 60

      return [
        hours
          ? `${hours} ${this.$caseWords(hours, ['час', 'часа', 'часов'])}`
          : undefined,
        minuts
          ? `${minuts} ${this.$caseWords(minuts, [
            'минута',
            'минуты',
            'минут'
          ])}`
          : undefined
      ].join(' ')
    }
  }
}
